module.exports = __webpack_public_path__ + "img/op_img-header-mobile.4b04137.png";